import ProcessRemindModal from './process-remind-modal.vue'
export default ProcessRemindModal
